// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import Address from "./types/address";

@jsonObject
export default class NervosInitialize extends PerunMessage {
  @jsonMember(String) clientPubKey: string;
  @jsonMember(Address) clientAddress: Address;
  @jsonMember(Boolean) egoisticClient = false;
  @jsonMember(String) codeHash: string;
  @jsonMember(String) l2Account = "";

  constructor(clientPubKey: string, clientAddress: Address, codeHash: string, l2Account?: string) {
    super();
    this.clientPubKey = clientPubKey;
    this.clientAddress = clientAddress;
    this.codeHash = codeHash;
    if (l2Account) {
      this.l2Account = l2Account;
    }
  }

  messageType(): MessageType {
    return NervosInitialize;
  }

  messageTypeName(): MessageTypeName {
    return "NervosInitialize";
  }
}
